const regionLessPaths = [
    '/account/',
    '/account/emailchange/',
    '/activate/',
    '/chromecast/',
    '/error/',
    '/global/',
    '/global/unsubscribe/',
    '/home/',
    '/oauth/',
    '/redeem-gift-card/',
    '/user-profile/',
    '/voucher/',
    /**
     * TO BE DELETED - CACHE TESTING https://jira.cbsi.com/browse/CBSENTWEB-1266
     */
    '/t-cache-fastly/',
];
const accountRegionalPaths = [
    '/account/signin/',
    '/account/signup/',
    '/account/check-email/',
    '/account/user-flow/',
];
const usRegionLessPaths = [
    '/',
    '/247sports/',
    '/amazon/',
    '/apple/',
    '/delta/',
    '/link/',
    '/partner/',
    '/partner-auth/',
    '/sportsline/',
    '/tv/', // rendezvous path
    '/walmartplus/',
];
const euRegionLessPaths = ['/intl/account/signin/', '/intl/forgotpassword/'];
const euRegions = [
    'AT',
    'BE',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GR',
    'HR',
    'HU',
    'IE',
    'IS',
    'IT',
    'LI',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
];

const supportedGSARegions = ['at', 'ch', 'de'];

const supportedLatamRegions = [
    'ar',
    'bo',
    'cl',
    'co',
    'cr',
    'do',
    'ec',
    'gt',
    'hn',
    'mx',
    'ni',
    'pa',
    'pe',
    'py',
    'sv',
    'uy',
    've',
];

const supportedNordicsRegions = ['dk', 'fi', 'no', 'se'];

const supportedRegions = [
    'au',
    'br',
    'ca',
    'fr',
    'gb',
    'ie',
    'it',
    'us',
    ...supportedGSARegions,
    ...supportedLatamRegions,
    ...supportedNordicsRegions,
];

const regionAliasMappings = {
    // GB subregions
    GG: 'GB',
    IM: 'GB',
    JE: 'GB',
    // IT subregions
    SM: 'IT',
    VA: 'IT',
    // FR subregions
    BL: 'FR',
    GF: 'FR',
    GLP: 'FR',
    GP: 'FR',
    GY: 'FR',
    MF: 'FR',
    MQ: 'FR',
    PM: 'FR',
    RE: 'FR',
    YT: 'FR',
};

export {
    accountRegionalPaths,
    euRegionLessPaths,
    euRegions,
    regionAliasMappings,
    regionLessPaths,
    supportedRegions,
    usRegionLessPaths,
};

export const PATHS_TO_IGNORE = [
    'tn',
    'api',
    '_next',
    'dev',
    'scripts',
    '__nextjs_original-stack-frame',
    // Feature-instance-only Storybook. Not shipped to prod, so this entry has no prod effect.
    'storybook',
].join('|');

/** Root static platform files — not matched by the PATHS_TO_IGNORE prefix regex. */
export const EXACT_PATHS_TO_IGNORE = [
    '/robots.txt',
    '/favicon.ico',
    '/sitemap.xml',
    '/manifest.json',
    '/sw.js',
];
